import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

import {ReactComponent as IconArrowUp} from '../../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconArrowDown} from '../../assets/icons/ic-arrow-down.svg'
import {ReactComponent as IconCheckBlue} from '../../assets/icons/ic-check-blue.svg'

const Dropdown = ({ type, isShow, isUpSide, isNumeric, value, valueArr, selectedParameters, handleClick, handleValueClick, selectWidth = 140 }) => {
    const openRef = useRef(null)
    const dropdownRef = useRef(null)
    const [optionList, setOptionList] = useState([])
    const [nowOption, setNowOption] = useState()
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 })

    const updateDropdownPosition = () => {
        if (openRef.current) {
            const rect = openRef.current.getBoundingClientRect()
            setDropdownPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX
            })
        }
    }
    
    const handleClickOutside = (event) => {
        if (openRef.current && openRef.current.contains(event.target)) {
            return
        }
        if(dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            handleClick(false)
        }
    }

    useEffect(() => {
        if (isShow) {
            updateDropdownPosition()
        }
    }, [isShow])

    useEffect(() => {                
        const codeSet = new Set(selectedParameters.map(item => item.measureParameterId));
        const codeList = valueArr.filter(item => {
            if(value === item.id){
                setNowOption(item.parameter);
            }           
            return item.parameter === "NONE" || value === item.id || !codeSet.has(item.id);            
        })
        .sort((a, b) => a.parameter.localeCompare(b.parameter));        
        setOptionList(codeList);
    }, [selectedParameters])

    useEffect(() => {
        window.addEventListener('mousedown', handleClickOutside);
    }, [])

    return (
        <div ref={openRef} className="absolute flex z-10 items-center ml-[52px] cursor-pointer bg-gradient-to-b from-[#5E5E5E] to-[#383838] text-white" onClick={() => { handleClick() }} style={{ padding: '7px 8px', width: selectWidth, height: 28, borderRadius: 6, border: '1px solid #5E5E5E'}}>
            <span className="" style={{ fontWeight: 300 }}>{ nowOption }</span>
            <div className="ml-auto flex">
                {
                    isShow ? <IconArrowUp /> : <IconArrowDown />
                }
            </div>
            {
                isShow && createPortal(
                <div ref={dropdownRef} className="fixed bg-[#1F1F1F] rounded-[6px] scrollbar scrollbar--gray z-20 text-white" style={{ maxHeight: 100, width: selectWidth, top: dropdownPosition.top, left: dropdownPosition.left, zIndex: 9999, padding: '8px 0', border: '1px solid #5E5E5E', boxShadow: '0px 12px 12px 0px #00000099' }}>
                    {
                        optionList.map((item, idx) => {
                            return (
                                <div 
                                    onClick={() => { handleValueClick(item) }}
                                    className="flex items-center px-2 room-list-item"
                                    key={`dropdown-list-item-${type}-${idx}`}
                                    style={{ height: 32, color: item.id === value ? '#3182F7' : '', fontWeight: 300 }}>
                                    { item.parameter }
                                    {
                                        item.id === value &&
                                        <IconCheckBlue className="ml-auto"/>
                                    }
                                </div>
                            )
                        })
                    }
                </div>,
                document.body
                )
            }
        </div>
    )
}

export default Dropdown